export default __webpack_public_path__ + "static/media/cliente02_color.b7c8d5c6.png";